import React, { useState, useEffect, Fragment,useContext } from 'react';
import PropTypes from 'prop-types';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import { Link } from 'react-router-dom';
import ModalPop from 'components/sales/modal/modal';
import { Button } from 'react-bootstrap';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import Notfound from 'pages/notfound/notfound';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import PanelCardWithHeading from 'components/tickets/panelCardWithHeading';

const PostponeInstallationApprovalsList = ({
  installationDateChangeListing,
  getInstallationDateChangeListing,
  filterDropdownList = [],
  match
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [listData, setListData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [isRender, setIsRender] = useState(false);
  const [filterData, setFilterData] = useState(
    {
      site_no: '',
      client_name: '',
      site_created_by: '',
      initial_date: '',
      old_date: '',
      changed_date: '',
      created_by: '',
      created_at: '',
      approved_by: '',
      approved_on: '',
      status: '1'
  });
  const [showFilter, setShowFilter] = useState(false);

  const headers = [
    'Site No.',
    'Client Name',
    'Site Created By',
    'Initial Installation Date',
    'Current Installation Date',
    'Requested Installation Date',
    'Raised By',
    'Raised On',
    'Action taken By',
    'Action taken On',
    'Remarks',
    'Status',
    'Actions'
  ];

  useEffect(() => {
    (async () => {
        setIsLoading(true);
        console.log(filterData)
        const res=await getInstallationDateChangeListing(1,null,filterData);
        setIsLoading(false);
      })();
  }, []);

  const applyFilter = async (filterData) => {
    localStorage.setItem("getInstallationDateChangeListing", JSON.stringify(filterData));
    setIsLoading(true);
    setFilterData(filterData);
    await getInstallationDateChangeListing(1,null, filterData);
    setIsLoading(false);
    filterToggle();
  };
  const filterToggle = () => {
      setShowFilter(!showFilter);
  };

  const headerBtns = () => {
      return (
          <Fragment>
              <Button
                  onClick={filterToggle}
                  className="filter-hamburger btn btn-transparent"
              >
                  <img src={Images?.Filter} alt=""/>
                  {localization.showFilters}
              </Button>
          </Fragment>
      );
  };

  const onPageChange = async (val) => {
      let filter = filterData === null ? null : filterData;
      setIsLoading(true);
      await getInstallationDateChangeListing(val.selected + 1,null,filterData);
      localStorage.setItem('page', val.selected + 1)
      setIsLoading(false);
  };

  useEffect(() => {
    const tableData = [
      "id",
      "site_no",
      "client_name",
      "site_created_by",
      "initial_date",
      "old_date",
      "changed_date",
      "created_by",
      "created_at",
      "approved_by",
      "approved_on",
      "request_remarks",
      'status'
    ];

    const actions = [
      { name: 'View Details', link: `${baseUrl}/view-postpone-installation-details` },
    ];
    // setListData()
    if (installationDateChangeListing && installationDateChangeListing?.data) {
      const data = installationDateChangeListing?.data?.map((element) =>
          Object.assign(
              {},
              ...tableData.map((key) => (
                  {
                   [key]: element[key],
                  })

              ),{Action: actions}
          )
      );
      data && setListData(data);
      setPageCount(Math.ceil(installationDateChangeListing?.total / installationDateChangeListing?.per_page));
      
    }
  }, [installationDateChangeListing]);

  return (  
    <>
    <Layout title={'Postpone Installtion Start Date Approvals'} 
      isLoading={isLoading}
      isGoback={true}
      Buttons={headerBtns}
      >
      {/* <div className="row mt-4">
        <div className="col-md-12">
          <div className="card shadow-sm"> */}
            {/* <PanelCardWithHeading title={'Request Listing'}/> */}
              {/* <div className="card-body"> */}
                <TableSection
                  data={listData}
                  isId={false}
                  headers={headers}
                  srNo={installationDateChangeListing?.from}
                  pageCount={pageCount}
                  onPageChange={onPageChange}
                />
                <ListFilters
                    showFilter={showFilter}
                    filterToggle={filterToggle}
                    applyFilter={(val) => applyFilter(val)}
                    installationDateApproval={true}
                />
              {/* </div> */}
            {/* </div>
          </div>
        </div> */}
    </Layout>
    </>
   )
};

PostponeInstallationApprovalsList.propTypes = {
  
};

export default PostponeInstallationApprovalsList;
